export const validateURL = (value) => {
    const regex = /^(https?:\/\/)?([\w\d-]+\.){1,}([a-z]{2,6})(:[0-9]{1,5})?(\/.*)?$/i;
    return regex.test(value);
};